import React, { useState } from "react";
import { FaUser, FaLock } from "react-icons/fa";
import Logo from "../assets/logo.webp";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import sample from "../assets/login.webp";
import mobilelogin from "../assets/mobilelogin.webp";
import { toast } from "react-toastify";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import Loader from "../components/Loader";
export default function SignIn() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [step, setStep] = useState(1);
    const [mobile, setMobile] = useState("");
    const [otp, setOtp] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const location = useLocation();
    const from = location.state?.from || "/";
    const handleLogin = async (e) => {
        e.preventDefault();
        if (!mobile || mobile.trim() === "") {
            toast.error("Mobile number is required");
            return;
        }
        const mobileRegex = /^[6-9]\d{9}$/;
        if (!mobile || !mobileRegex.test(mobile)) {
            toast.error("Please enter a valid 10-digit mobile number");
            return;
        }
        const loginData = {
            mobile_number: mobile,
            password: "123456"
        };
        try {
            setLoading(true);
            let url = webEndPoint + "user/login";
            const response = await makeRequest("post", url, loginData);
            if (response?.message === "Login successful") {
                setLoading(false);
                localStorage.clear();
                localStorage.setItem("APP_VERSION", "2");
                localStorage.setItem("userID", response.data.rfId);
                localStorage.setItem("userToken", response?.token);
                toast.success("User Login successfully!");
                setMobile("");
                navigate(from, { replace: true });
            } else {
                toast.error("Login failed. Please check your credentials");
                return;
            }
        } catch (err) {
            if (err?.message) {
                toast.error("First Sign up and then login to book your order (Any doubt : 9360990836)");
                return;
            } else {
                toast.error(err.message || "Something went wrong");
                return;
            }
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="page-container">
            <Loader loading={loading} />
            <Header />
            <div className="register-wrapper">
                <div className="register-left">
                    <img src={sample} alt="fashion" className="side-img desktop-img" />
                    <img src={mobilelogin} alt="mobile" className="side-img mobile-img" />
                </div>
                <div className="register-right">
                    <div className="register-card">
                        <h2>Welcome Back</h2>
                        <div className="gradient-line"></div>
                        <p className="subtitle">Sign in to continue Senthan Amuthan</p>
                        <form onSubmit={handleLogin} className="login-form">
                            <div className="input-group">
                                <FaUser />
                                <input
                                    type="text"
                                    placeholder="Mobile Number"
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value)} />
                            </div>
                            <button type="submit" className="register-btn">Login</button>
                            <p className="login-link">
                                Don’t have an account? <Link to="/signup">Sign Up</Link>
                            </p>
                        </form>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    );
}